<template>
	<div class="help-step-wrapper" :class="{'mobile': getMobileAppState}">
		<div
		v-for="(item, index) in helpTopics"
		class="help-topic"
		:key="`indiceItem${index}`">
			<!-- Topic step number -->
			<div class="bullet">{{index+1}}</div>
			<!-- Text -->
			<div class="text" v-html="item"/>
			<!-- Button -->
			<button-tertiary
			icon="arrow-right-full"
			buttonSize="tiny"
			@clicked="emit('helperStepUpdate', index+1)"/>
		</div>
	</div>
</template>

<script setup>
import ButtonTertiary from '@/components/generic/buttons/Tertiary'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

const { getMobileAppState } = mapGetters()

const props = defineProps({
    helpTopics: Array
})

/* Emmitters */
const emit = defineEmits(['helperStepUpdate'])
</script>

<style lang="scss" scoped>
.help-step-wrapper {
	gap: 0;

    &.mobile {
        padding: 0 16px;
    }

	.help-topic {
		width: 100%;
		min-height: 62px;
		padding: 16px 0;

		display: flex;
		align-items: center;

		@include H5-Medium;
		color: var(--secondary-dark-2);
		border-bottom: 1px solid var(--secondary-light-2);

		cursor: default;

		&:last-of-type {
			border: none;
		}

		.bullet {
			width: 24px;
			height: 24px;
			margin-right: 8px;
			margin-top: 4px;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;

			@include H8-Regular;
			color: var(--secondary-light-4);

			background-color: var(--secondary-dark-2);
			border-radius: 50%;
		}

		.text {
			width: calc(100% - 24px);
			margin-right: 8px;
			margin-top: 4px;
		}
	}
}
</style>
